export default "__VITE_ASSET__CwHTRa7q__"